import { render, staticRenderFns } from "./CreateCustomRequest.vue?vue&type=template&id=0ee947da&scoped=true&"
import script from "./CreateCustomRequest.vue?vue&type=script&lang=ts&"
export * from "./CreateCustomRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee947da",
  null
  
)

export default component.exports